import React from "react";
import logoViz from "../../assets/images/logo-viziona-white.png";
import "./header.css";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  return (
    <div className="header">
      <div>
        <span onClick={() => navigate(-1)} className="icon-arrow-circle-left" />
      </div>
      <div>
        <img src={logoViz} />
      </div>
      <div className="right-header-section"></div>
    </div>
  );
}
